(function () {
  'use strict';

  var SECTION_SELECTOR = '.oddit-section-collection-tabs';

  function initSection(section) {
    if (!section || section.__odditTabsInit) return;
    section.__odditTabsInit = true;

    var tabs = section.querySelectorAll('.oddit-section-collection-tabs__tab');
    var panels = section.querySelectorAll('.oddit-section-collection-tabs__panel');
    var cta = section.querySelector('[data-tabs-cta]');

    if (!tabs.length) return;

    // Per-tab CTA (RC-59). One <a> in the DOM; its label and href are swapped
    // from the active tab's data attributes. Keeps the centred cta-wrap layout
    // and stylesheet untouched, and degrades to the first tab's CTA without JS.
    function syncCta(tab) {
      if (!cta) return;
      var label = tab.getAttribute('data-cta-label') || '';
      var link = tab.getAttribute('data-cta-link') || '';

      if (!label) {
        // Inline style, not [hidden] — the stylesheet sets display:block on
        // .__cta, which would beat the UA rule for the hidden attribute.
        cta.style.display = 'none';
        return;
      }

      // Empty string clears the inline value so the stylesheet's display:block
      // applies again, rather than hard-coding the display mode here.
      cta.style.display = '';
      cta.textContent = label;
      cta.setAttribute('href', link || '#');
    }

    function activateTab(tab) {
      var target = tab.getAttribute('aria-controls');
      if (!target) return;

      tabs.forEach(function (t) {
        var isActive = t === tab;
        t.classList.toggle('oddit-section-collection-tabs__tab--active', isActive);
        t.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });

      panels.forEach(function (panel) {
        var isActive = panel.id === target;
        panel.classList.toggle('oddit-section-collection-tabs__panel--active', isActive);
      });

      syncCta(tab);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        activateTab(tab);
      });
      tab.addEventListener('keydown', function (e) {
        var key = e.key;
        if (key !== 'ArrowLeft' && key !== 'ArrowRight') return;
        e.preventDefault();
        var idx = Array.prototype.indexOf.call(tabs, tab);
        var nextIdx = key === 'ArrowRight'
          ? (idx + 1) % tabs.length
          : (idx - 1 + tabs.length) % tabs.length;
        tabs[nextIdx].focus();
        activateTab(tabs[nextIdx]);
      });
    });

    initSwatches(section);
    initHoverVideos(section);
  }

  function initSwatches(section) {
    var groups = section.querySelectorAll('.oddit-section-collection-tabs__card-swatches');

    groups.forEach(function (group) {
      var swatches = group.querySelectorAll('.oddit-section-collection-tabs__swatch');
      if (!swatches.length) return;

      function goToSwatch(swatch, e) {
        // Swatches live inside the card <a>; stop the card link from firing,
        // then navigate to the swatch's own (sibling color) product.
        if (e) {
          e.preventDefault();
          e.stopPropagation();
        }
        var url = swatch.getAttribute('data-swatch-url');
        if (url) {
          window.location.href = url;
        }
      }

      swatches.forEach(function (swatch) {
        swatch.setAttribute('role', 'link');
        swatch.setAttribute('tabindex', '0');

        swatch.addEventListener('click', function (e) {
          goToSwatch(swatch, e);
        });
        swatch.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
            goToSwatch(swatch, e);
          }
        });
      });
    });
  }

  // Hover-to-play for cards whose second media is a video (RC-58).
  //
  // The stylesheet already fades `__card-img--hover` in on card hover, so this
  // only has to drive playback. Gated to devices that actually hover, so touch
  // users never download the clip, and skipped entirely under reduced-motion.
  // Mirrors initHoverVideos in oddit-section-collection-grid.js.
  function initHoverVideos(section) {
    if (!window.matchMedia) return;
    if (!window.matchMedia('(hover: hover)').matches) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var videos = section.querySelectorAll('video[data-hover-video]');

    videos.forEach(function (video) {
      if (video.__odditHoverVideoBound) return;
      video.__odditHoverVideoBound = true;

      // Bind to the card link so the whole card is the trigger, matching the
      // CSS selector that reveals the video.
      var trigger = video.closest('.oddit-section-collection-tabs__card-link') || video.parentElement;
      if (!trigger) return;

      function play() {
        // Muted is required for programmatic playback under autoplay policies;
        // the attribute alone isn't always honoured, so set the property too.
        video.muted = true;
        if (video.preload === 'none') video.preload = 'auto';
        var attempt = video.play();
        // Rejects harmlessly when the pointer leaves before the load resolves.
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(function () {});
        }
      }

      function stop() {
        video.pause();
        try {
          video.currentTime = 0;
        } catch (e) {
          // Seeking before metadata exists throws in some browsers; harmless.
        }
      }

      trigger.addEventListener('mouseenter', play);
      trigger.addEventListener('mouseleave', stop);
      // Keyboard parity: the card link is focusable, so play on focus too.
      trigger.addEventListener('focusin', play);
      trigger.addEventListener('focusout', stop);
    });
  }

  function initAll(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll
      ? scope.querySelectorAll(SECTION_SELECTOR)
      : [];
    sections.forEach(initSection);
    if (scope.matches && scope.matches(SECTION_SELECTOR)) {
      initSection(scope);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    initAll(e.target);
  });
})();
